import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Store getAccessToken function reference (will be set from App.js)
let getAccessTokenFn = null;

export function setTokenGetter(fn) {
  getAccessTokenFn = fn;
}

// Request interceptor to get fresh token before each request
axiosClient.interceptors.request.use(
  async (config) => {
    try {
      // Get fresh token from Kinde before each request
      if (getAccessTokenFn) {
        const token = await getAccessTokenFn();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error("Failed to get access token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle auth errors
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Let the app handle the logout - dispatch event for listeners
      window.dispatchEvent(new CustomEvent("auth-unauthorized"));
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
